import Button from '@mui/material/Button'
import { useSearchParams } from 'next/navigation'
import type { FC, ReactNode } from 'react'
import { useAnalytics } from '../../context/Analytics'

interface GetStartedButtonProps {
  id?: string
  inviteCode?: string
  buttonSize?: 'small' | 'medium'
  buttonText?: ReactNode
  color?: 'primary' | 'secondary'
  ctaName?: string
}

const GetStartedButton: FC<GetStartedButtonProps> = ({
  inviteCode,
  id = 'get-started-button',
  buttonText = 'Get Started',
  buttonSize = 'medium',
  color = 'primary',
  ctaName,
}) => {
  const { track, events } = useAnalytics()
  const currentSearchParams = useSearchParams()
  const urlParams = new URLSearchParams(currentSearchParams.toString())
  let urlPath = '/default'

  if (inviteCode) {
    urlPath = ''
    urlParams.set('inviteCode', inviteCode)
  }

  return (
    <Button
      id={id}
      data-testid={id}
      variant="contained"
      color={color}
      size={buttonSize}
      className="get-started w-full text-nowrap md:w-fit"
      href={`${
        process.env.NEXT_PUBLIC_CAFE_ORIGIN
      }/prequalification${urlPath}?${urlParams.toString()}`}
      onClick={() =>
        track?.(events.INTERACTION.ClickCta, {
          ...(ctaName ? { cta: ctaName } : {}),
        })
      }
    >
      {buttonText}
    </Button>
  )
}

export default GetStartedButton
